export default "https://assets.egbcdn.net/assets/packs/_/images/fire-a2b10b748e7fefecef8472f0a10ccd45.svg";